export function statsReducer(state = {
    SUBSCRIPTIONS : null,
    CITY_STATS: null,
    TOP_PRODUCTS: null,
    
},{
    type,
    payload
}){
    switch(type){
        
        case "GET_SUBSCRIPTIONS_STATS":
            let list = Object.assign({}, state)
            list.SUBSCRIPTIONS = payload
            return list   

        case "GET_STATS_CLIENTS_CITY":
            let list2 = Object.assign({}, state)
            list2.CITY_STATS= payload
            return list2   

        case "GET_TOP_PRODUCTS":
            let list3 = Object.assign({}, state)
            list3.TOP_PRODUCTS= payload
            return list3    

        default:
            return state;
    }
}